<template>
  <div class="card shadow-sm border-0">
    <div class="card-header">

      <h5 class="mb-0 text-primary">Record Supplier Transaction</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="saveTransaction">
        <div class="form-group">
          <label>Purchase Order</label>
          <select class="form-control" v-model="form.purchase_id" required>
            <option value="null">Select Purchase</option>
            <option v-for="s in purchases" :key="s.id" :value="s.id">{{ s.purchase_order }}</option>
          </select>
        </div>

        <div class="form-group">
          <label>Mode of Payment</label>
          <select v-model="form.payment_method" class="form-control">
            <option value="null" disabled>Select Payment Mode</option>
            <option value="cash">Cash</option>
            <option value="bank_transfer">Bank Transfer</option>
            <option value="cheque">Cheque</option>
            <option value="mobile_money">Mobile Money</option>
            <option value="credit_note">Credit Note</option>
          </select>
        </div>



          <label>Date</label>
          <date-range-picker :auto-apply="autoApply" :single-date-picker=true v-model="form.datePicker" required class="custom-width-datepicker" />


        <div class="form-group">
          <label>Reference</label>
          <input type="text" class="form-control" v-model="form.reference" placeholder="Optional">
        </div>

        <div class="form-group">
          <label>Amount</label>
          <input type="number" step="0.01" class="form-control" v-model="form.amount" required>
        </div>

        <button type="submit" class="btn btn-primary">
          <i class="fa fa-save"></i> Save Transaction
        </button>
      </form>
    </div>
  </div>
</template>

<script>
 import moment from "moment";
import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
export default {
     name: "SupplierPaymentRecording",
components: {
    DateRangePicker

  },
  data() {
    return {
      purchases: [],
      form: {
        purchase_id: null,
        supplier_id: '',
        payment_method: null,
        type: '',
        datePicker: {
                startDate: null,
            },
            date:'',
        reference: '',
        amount: ''
      },
      autoApply: true,
    append_to_body: true,
    datepicker_opens: 'right',
    ranges: false,
    }
  },
  created() {
     console.log('Supplier prop received in child:', this.supplier);
    this.fetchPurchases();
  },

  methods: {
    fetchPurchases() {

            const params = new URLSearchParams(window.location.search);
            this.form.supplier_id = params.get('id')


      fetch(`/api/purchases?supplier_id=${params.get('id')}`)
        .then(res => res.json())
        .then(data => {
          this.purchases = data.purchases;
        });
    },
    saveTransaction() {
         const urlParams = new URLSearchParams(window.location.search);

        this.form.date = moment(this.form.datePicker.startDate).format('YYYY-DD-MM')
      axios.post('/api/suppliers/transactions', {...this.form})
    .then(res => {

        this.form = {  type: '', date: '', reference: '', amount: '' };
         window.location.href=`/suppliers?id=${urlParams.get('id')}`

      }).catch(err=>{
        this.$toas.push({
            type: 'error',
            message: 'There was an error' + err,
        })
      });
    }
  }
}
</script>
